module.exports = __webpack_public_path__ + "0a197a6b4e6cf732788c83dff28782fd.svg";